import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { captureAffiliateReferralFromUrl } from "./features/onboarding/affiliate-referral";
import "./styles/globals.css";

// Sentry só liga com DSN configurado (build arg do deploy); sem DSN é no-op.
// Somente captura de erros (sem tracing/replay). LGPD: sendDefaultPii=false e
// beforeSend remove identidade do usuário e cookies/headers do request.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "local",
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    sendDefaultPii: false,
    beforeSend(event) {
      delete event.user;
      if (event.request) {
        delete event.request.cookies;
        delete event.request.headers;
      }
      return event;
    },
  });
}

// Indicação de afiliado (hub#739): grava `?ref=` antes de qualquer navegação. O usuário
// chega pelo link, passa por três telas do wizard e recarrega no meio — sem capturar
// aqui, a indicação se perde e o afiliado nunca recebe pelo cliente que trouxe.
captureAffiliateReferralFromUrl();

// Após um deploy, a SPA já carregada pode tentar buscar um chunk lazy com hash
// antigo (404). O Vite dispara 'vite:preloadError' — recarregamos a página para
// pegar o index.html novo (com os chunks corretos), evitando a tela de erro.
// Guard de tempo impede loop caso o recarregamento não resolva.
window.addEventListener("vite:preloadError", () => {
  const KEY = "imobgo.lastChunkReload";
  const now = Date.now();
  const last = Number(sessionStorage.getItem(KEY) ?? "0");
  if (now - last < 10_000) return;
  sessionStorage.setItem(KEY, String(now));
  window.location.reload();
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element in index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
